module.exports = __webpack_public_path__ + "img/domain stup.dbef3ba7.svg";